import React from 'react';

import './index.less';

import { MoneyBackGuarantee } from '../../MoneyBackGuarantee';
import { GiftCheckboxBanner } from '../../GiftCheckboxBanner';
import { FamilyCheckboxBanner } from '../../FamilyCheckboxBanner';
import { PaymentSummaryTable, WHEN_REDEEMED } from '../../PaymentSummaryTable';
import { InteractionProps as CheckboxBannerInteractionProps } from '../../CheckboxBanner';
import { PaymentSummaryProps } from '../../CheckoutStages';

interface Props {
	giftCheckboxBanner?: CheckboxBannerInteractionProps;
	familyCheckboxBanner?: CheckboxBannerInteractionProps;
	summary: PaymentSummaryProps;
}

export const DesktopPaymentSummary: React.SFC<Props> = ({
	summary,
	giftCheckboxBanner,
	familyCheckboxBanner
}) => {
	const { familyUpgradePrice, isSubscriptionChange, moneyBackGuarantee, startDate } = summary;

	return (
		<div className="DesktopPaymentSummary">
			<PaymentSummaryTable {...summary} />
			{familyCheckboxBanner && (
				<div className="DesktopPaymentSummary__banner">
					<FamilyCheckboxBanner {...familyCheckboxBanner} familyUpgradePrice={familyUpgradePrice} />
				</div>
			)}
			{!isSubscriptionChange &&
				giftCheckboxBanner && (
					<div className="DesktopPaymentSummary__banner">
						<GiftCheckboxBanner
							{...giftCheckboxBanner}
							startsWhenRedeemed={startDate === WHEN_REDEEMED}
						/>
					</div>
				)}

			{moneyBackGuarantee && (
				<div className="DesktopPaymentSummary__banner">
					<MoneyBackGuarantee message={moneyBackGuarantee} />
				</div>
			)}
		</div>
	);
};
